import { combineReducers } from 'redux-immutable'
import { Map } from 'immutable';
import settingsReducer from './settings'
import websiteReducer from './website'
import programReducer from './program';
import dashboardReducer from './dashboard';
import generalReducer from './ general';
import printReducer from './print';
import overlayReducer from './overlay';


const INIT_STATE = Map()

const combinedReducer = combineReducers({
    general: generalReducer,
    overlay: overlayReducer,
    dashboard: dashboardReducer,
    program: programReducer,
    website: websiteReducer,
    settings: settingsReducer,
    print: printReducer
});

const uiReducer = (state = INIT_STATE, action) => combinedReducer(state, action);

export default uiReducer;